export class GlobalConstants {
    public static tobaccoAgreement = false;
    public static showTobaccoAgreement = false;
}